import styled, { keyframes, css } from 'styled-components';
import { media } from 'src/common/styles/breakpoints';
import {FC} from "react";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const SpinnerLoader = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  border: 0.75rem solid #E8E8E8;
  border-top: 0.75rem solid #08B5F7;
  border-radius: 50%;
  animation: ${rotate} 2s linear infinite;

  ${media.w.min.px576(css`
    border-width: 1rem;
    border-top-width: 1rem;
  `)};
`;

const SpinnerContainer = styled.div`
  width: 11rem;
  height: 11rem;
  position: relative;

  ${media.w.min.px576(css`
    width: 12.75rem;
    height: 12.75rem;
  `)};
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
`;

interface LoaderProps {
  msgId?: MessageId;
  className?: string;
}

export const Spinner: FC<LoaderProps> = ({ msgId, className }) => {
  return (
      <Wrapper className={className}>
        <SpinnerContainer>
          <SpinnerLoader />
        </SpinnerContainer>
      </Wrapper>
  );
};
